import React from "react";
import { Props } from "./types";
import { ProjectStrategicAxisEdition } from "./projectStrategicAxisEdition";
import { ProjectStrategicAxisCreation } from "./projectStrategicAxisCreation";
import styles from "./styles.scss";

function ProjectStrategicAxesTable({
  strategicAxes,
  projectStrategicAxes,
  project,
}: Props) {
  return (
    <div className={styles.projectStrategicAxes}>
      {strategicAxes.map((strategicAxis) => {
        const projectStrategicAxis = projectStrategicAxes.find(
          ({ strategicAxisId }) => strategicAxisId === strategicAxis.uuid,
        );

        return projectStrategicAxis ? (
          <ProjectStrategicAxisEdition
            key={strategicAxis.uuid}
            strategicAxis={strategicAxis}
            projectStrategicAxis={projectStrategicAxis}
          />
        ) : (
          <ProjectStrategicAxisCreation
            key={strategicAxis.uuid}
            project={project}
            strategicAxis={strategicAxis}
          />
        );
      })}
    </div>
  );
}

export { ProjectStrategicAxesTable };
